import { TransportConstantsControllerGetTimeMethod } from '../methods/transport-constants-controller/get-time.method';

export class TransportConstantsController {
  public readonly getTime = new TransportConstantsControllerGetTimeMethod();
}
